"use client";
import { useSelector } from "react-redux";
import { useRef, useState } from "react";

import { BlogServices } from "@/services";
import { RootState } from "@/app/store";

function useBlog() {
  const blogRef = useRef<HTMLDivElement | null>(null);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 5;
  const { selectedCategory } = useSelector((state: RootState) => state.blog);
  const { data: allBlogs, isLoading: blogLoading } =
    BlogServices().useGetAllBlog({
      page: currentPage,
      category: selectedCategory._id,
      excludeLatest: true,
    });

  const { data: latestBlog } = BlogServices().useGetAllBlog({
    category: selectedCategory._id,
    onlyLatest: true,
  });

  const handlePageChange = (page: number) => {
    if (blogRef.current) {
      blogRef.current.scrollIntoView({ behavior: "smooth" });
    }
    setCurrentPage(page);
  };

  return {
    allBlogs,
    blogLoading,
    currentPage,
    latestBlog,
    pageSize,
    blogRef,
    handlePageChange,
  };
}
export default useBlog;
